import React, { useEffect, useState } from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import axios from "../../axios";
import CheckCheckout from "./CheckCheckout";

const CheckoutCallback = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  var url = new URLSearchParams(location.search);
  var statusValue = url.get("status");
  var message = url.get("message");
  // const [isDineIn] = useState(() => {
  //   const flag = localStorage.getItem("open_check_dine_in") === "1";
  //   localStorage.removeItem("open_check_dine_in");
  //   return flag;
  // });

  const isDineIn = localStorage.getItem("type") === "in_dining";
  console.log("isDineIn", isDineIn);
  const open_check_restaurant_id = localStorage.getItem(
    "open_check_restaurant_id",
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const restaurant_id = searchParams.get("restaurant_id");
  const navigate = useNavigate();

  const { t } = useTranslation();

  // Get the value of the 'status' parameter

  const handleDineInSuccess = () => {
    toast.success(t("Request received! A waiter will be with you shortly."), {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    const roomBeforeRedirect = localStorage.getItem(
      "room_uuid_before_redirect",
    );

    navigate(`/${roomBeforeRedirect}`);
  };

  return (
    <>
      <HeaderInner headerName={"Checkout"} />
      <main className="bg-white back-white v2">
        {
          <CheckCheckout
            status={statusValue}
            message={message}
            urlAPI={`orders/${open_check_restaurant_id ? "open-check-receipt" : "order-receipt"}`}
            navigatUrl={
              open_check_restaurant_id || isDineIn
                ? "RestaurantOrderPlaced?source=dine-in"
                : "RestaurantOrderPlaced"
            }

            // onSuccess={isDineIn ? handleDineInSuccess : undefined}
          />
        }
        {/* <h3>Hi</h3> */}
      </main>
    </>
  );
};

export default CheckoutCallback;
